document.addEventListener("DOMContentLoaded", () => {
  const checkboxes = document.querySelectorAll(".input_checkbox"),
  addOnQtyElement = document.getElementById("addOnQty"),
  addOnPriceElement = document.getElementById("addOnPrice"),
  sugestedTotPriceElement = document.getElementById("sugestedTotPriceDesktop"),
  fbtGrid = document.querySelector(".fbt-grid"),
  submitButton = document.querySelector('#ATCFBT'),
  currencySymbol = document.querySelector("header")?.getAttribute("data-currency-symbol") || "$",
  firstProductElement = document.querySelector(".first-product"),
  firstProductPrice = firstProductElement ? parseFloat(firstProductElement.getAttribute("data-price-fbt")) || 0 : 0;

  const getProductDataFromElement = (checkbox) => {
    const parentElement = checkbox.closest(".addons_product");
    return parentElement ? {
      productId: parentElement.getAttribute("data-fbt-id"),
      priceFbt: parseFloat(parentElement.getAttribute("data-price-fbt")) || 0
    } : { productId: null, priceFbt: 0 };
  }

  const getCheckedProductIds = () => {
  const productVarIds = [firstProductElement ? Number(firstProductElement.getAttribute("data-fbt-id")) : null].filter(Boolean);
  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      const { productId } = getProductDataFromElement(checkbox);
      productVarIds.push(Number(productId)); // Ensure all IDs are numbers
    }
  });
  return productVarIds;
};


  const updateCheckedProducts = () => {
    let totalCheckedQty = 0, totalPrice = 0;
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const { priceFbt } = getProductDataFromElement(checkbox);
        totalCheckedQty++;
        totalPrice += priceFbt;
      }
    });

    fbtGrid?.classList.toggle("no-checked-product", totalCheckedQty === 0);
    addOnQtyElement.textContent = totalCheckedQty;
    addOnQtyElement.parentElement.style.display = totalCheckedQty ? "block" : "none";
    if (currencySymbol === '€') {
    addOnPriceElement.textContent = `${(totalPrice / 100).toFixed(2).replace('.', ',')}${currencySymbol}`;
    sugestedTotPriceElement.textContent = `${((totalPrice + firstProductPrice) / 100).toFixed(2).replace('.', ',')}${currencySymbol}`;
    }
    else{
    let formattedTotalPrice = (totalPrice / 100).toFixed(2);
    let formattedSuggestedPrice = ((totalPrice + firstProductPrice) / 100).toFixed(2);

  
    if (currencySymbol === 'kr.') {
        formattedTotal__Price = formattedTotalPrice.replace('.', ',');
        formattedSuggested__Price = formattedSuggestedPrice.replace('.', ',');
        addOnPriceElement.textContent = `${formattedTotal__Price} ${currencySymbol}`;
        sugestedTotPriceElement.textContent = `${formattedSuggested__Price} ${currencySymbol}`;
    }
      else{
         addOnPriceElement.textContent = `${currencySymbol}${formattedTotalPrice}`;
        sugestedTotPriceElement.textContent = `${currencySymbol}${formattedSuggestedPrice}`;
      }

   
    }
    const computedPrice = (totalPrice + firstProductPrice) / 100;
      

    const otherBenefitsElement = document.querySelector('.otherBenefits');

   // Check the condition and toggle the hidden class
   if (computedPrice < 35) {
     otherBenefitsElement.classList.add('hidden');
   } else {
     otherBenefitsElement.classList.remove('hidden');
   }
  }

  updateCheckedProducts();

  fbtGrid?.addEventListener("change", (event) => {
    if (event.target?.classList.contains("input_checkbox")) updateCheckedProducts();
  });

  submitButton.addEventListener("click", () => {
    const productVarIds = getCheckedProductIds();
    console.log('Product IDs to add to cart:', productVarIds);
    if (productVarIds.length) ajaxCallUpdateCart(productVarIds);
  });

  const ajaxCallUpdateCart = (productVarIds) => {
  const formData = {
    items: productVarIds.map(id => ({ id, quantity: 1 }))
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(() => {
    // Page cart type (no cart drawer/notification): redirect to the cart page after adding instead of opening a drawer that isn't rendered.
    if (!document.querySelector('cart-drawer') && !document.querySelector('cart-notification')) {
      window.location =
        (window.routes && window.routes.cart_url) || (window.Shopify.routes.root + 'cart');
      return;
    }

    $('.header #cart-icon-bubble').load(location.href + " #cart-icon-bubble");
    $('.header-dropdown_menu #cart-icon-bubble').load(location.href + " #cart-icon-bubble");

    // Load CartDrawer and THEN run drawer-related logic
    $('#CartDrawer').load(location.href + " #CartDrawer", function () {
      const drawer = document.querySelector(".drawer");
      const cartDrawer = document.querySelector("cart-drawer");
      const overlay = document.getElementById("CartDrawer-Overlay");

      if (drawer) {
        drawer.classList.remove("is-empty");
        drawer.classList.add("animate", "active");
        // Lock body scroll like the normal drawer open() does — this manual open
        // bypasses cart-drawer.js, so add the class here too.
        document.body.classList.add("overflow-m-hidden");

        let currentUrl = new URL(window.location.href);
        console.log('Current URL:', currentUrl.href);
        currentUrl.searchParams.set('cartOpen', 'true');
        console.log('Updated URL:', currentUrl.href);
        window.history.replaceState({}, '', currentUrl);
      }

      if (overlay && cartDrawer) {
        overlay.addEventListener("click", () => {
          cartDrawer.classList.remove("active");
          document.body.classList.remove("overflow-m-hidden");
        });
      }
    });
  })
  .catch(console.error);
};

});